import PageMeta from '../../components/common/PageMeta'
import Calendar from './Calendar/Calendar'
import Funnels from './Funnel/Funnels'
import OpenNotes from './Notes/OpenNotes'

export default function DashboardPage() {
    return (
        <>
            <PageMeta title='Início | CRM' description='Página inicial do CRM' />
            <div className='grid grid-cols-12 gap-4'>
                <div className='col-span-12 space-y-6 sm:col-span-8'>
                    <Calendar />
                    <Funnels />
                </div>

                <div className='col-span-12 sm:col-span-4 space-y-4'>
                    <OpenNotes />
                </div>
            </div>
        </>
    )
}
